export class ContactsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getApplicationContacts({ applicationId }) {
    return this.#http.get(`/contacts/v2/${applicationId}`);
  }

  async getLoanParties({ applicationId }) {
    return this.#http.get(`/contacts/v2/${applicationId}/parties`);
  }

  async getLoanSummaryContacts({ applicationId, internalUsersOnly = false }) {
    const params = {
      internalUsersOnly,
    };

    // Loan-editor secondary read: this is a best-effort read for every user (a subtree-scoped TPO
    // broker is additionally not authorized for internal-user contact data), so a 403 here must
    // always degrade the panel, not toast — unconditional, matching
    // applicationPricingStatusApi/channelApi (DEV-4226).
    return this.#http.get(`/contacts/v2/${applicationId}/summary`, {
      params,
      skipResponseInterceptor: { forbiddenError: true },
    });
  }
}
